import { pluralRu } from "@mylaunch/utils"
import { LuBadgeCheck } from "react-icons/lu"
import { QueryBoundary } from "~/components/query-boundary"
import { SettingsItem } from "~/components/settings-item"
import { SettingsItemSkeleton } from "~/components/settings-item-skeleton"
import { SpinnerFallback } from "~/components/spinner-fallback"
import { GroupsGrid } from "./groups-grid"
import { useMembers } from "../hooks/use-members"

export function Catalog() {
  return (
    <div className="flex flex-col">
      <QueryBoundary loadingFallback={<SettingsItemSkeleton className="px-m border-b" />}>
        <MembersItem />
      </QueryBoundary>
      <QueryBoundary
        loadingFallback={<SpinnerFallback />}
      >
        <div className="p-m">
          <GroupsGrid />
        </div>
      </QueryBoundary>
    </div>
  )
}

const MembersItem = () => {
  const { data: members } = useMembers()

  return (
    <SettingsItem
      to="/topic/8"
      className="px-m border-b"
      icon={<LuBadgeCheck className="size-icon-m text-primary" />}
      text={`${members.length} ${pluralRu(members.length, "эксперт", "эксперта", "экспертов")}`}
    />
  )
}
